import EmailStats from './container';

export default EmailStats;
